import { render, staticRenderFns } from "./UniversalSearchModal.vue?vue&type=template&id=fa32d058&scoped=true"
import script from "./UniversalSearchModal.vue?vue&type=script&lang=js"
export * from "./UniversalSearchModal.vue?vue&type=script&lang=js"
import style0 from "./UniversalSearchModal.vue?vue&type=style&index=0&id=fa32d058&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa32d058",
  null
  
)

export default component.exports